import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { API_URL } from 'app/helpers/globals';
import { map, share } from 'rxjs/operators';

export type GenerateInfringementsForCompanyAndAllSubCompaniesStatResponse = {
  queueSize: number;
}

export type CompanyNamesResponse = {
  companies: string;
  error: string | null;
}

export type DeviceInfosResponse = {
  device: string;
  error: string | null;
}

@Injectable({
  providedIn: 'root'
})
export class AdminPanelService {

  constructor(
    private readonly http: HttpClient
  ) { }


  generateInfringementsForCompanyAndAllSubCompaniesStat() {
    return this.http.get<GenerateInfringementsForCompanyAndAllSubCompaniesStatResponse>(`${API_URL}generateInfringementsForCompanyAndAllSubCompaniesStat`,
      { withCredentials: true })
      .pipe(share()).pipe(map((response) => response));
  }

  generateInfringementsForCompanyAndAllSubCompaniesCancel() {
    return this.http.post(`${API_URL}generateInfringementsForCompanyAndAllSubCompaniesCancel`, {},
      { withCredentials: true })
      .pipe(share()).pipe(map((response) => response));
  }

  generateInfringementsForCompanyAndAllSubCompanies(clientId: number) {
    return this.http.post(`${API_URL}generateInfringementsForCompanyAndAllSubCompanies`, { clientId: clientId },
      { withCredentials: true })
      .pipe(share()).pipe(map((response) => response));
  }

  calculateBills(year: number, quarter: number) {
    return this.http.get(`${API_URL}calculateBills2023Q1?year=${year}&q=${quarter}`,
      { withCredentials: true })
      .pipe(share()).pipe(map((response) => response));
  }

  reloadDataForFile(hash: string) {
    return this.http.get(`${API_URL}reloadDataForFileWith?hash=${hash}`,
      { withCredentials: true })
      .pipe(share()).pipe(map((response) => response));
  }

  reactivateNotPayingClient(clientId: string) {
    return this.http.get(`${API_URL}resellerProBilling/reactivateDontPayingClient/${clientId}`,
      { withCredentials: true })
      .pipe(share()).pipe(map((response) => response));
  }

  resendActivationEmail(uname: string, emailAddress: string) {
    return this.http.get(`${API_URL}company/resendActivationEmail?uname=${uname}&emailAddress=${emailAddress}`,
      { withCredentials: true })
      .pipe(share()).pipe(map((response) => response));
  }

  getDriverCompanyNames(driverId?: string, cardNumber?: string) {
    const params = [] as string[];
    if (driverId) {
      params.push(`driverId=${encodeURIComponent(driverId)}`);
    }
    if (cardNumber) {
      params.push(`cardNumber=${encodeURIComponent(cardNumber)}`);
    }
    const query = params.length ? `?${params.join('&')}` : '';
    return this.http.get<CompanyNamesResponse>(`${API_URL}getDriverCompanyNames${query}`,
      { withCredentials: true })
      .pipe(share()).pipe(map((response) => response));
  }

  getVehicleCompanyNames(vehicleId?: string, vin?: string) {
    const params = [] as string[];
    if (vehicleId) {
      params.push(`vehicleId=${encodeURIComponent(vehicleId)}`);
    }
    if (vin) {
      params.push(`vin=${encodeURIComponent(vin)}`);
    }
    const query = params.length ? `?${params.join('&')}` : '';
    return this.http.get<CompanyNamesResponse>(`${API_URL}vehicle/getVehicleCompanyNames${query}`,
      { withCredentials: true })
      .pipe(share()).pipe(map((response) => response));
  }

  getDeviceInfos(imei: string) {
    return this.http.get<DeviceInfosResponse>(`${API_URL}device/getDeviceInfos?imei=${encodeURIComponent(imei)}`,
      { withCredentials: true })
      .pipe(share()).pipe(map((response) => response));
  }

}
